var exports = {
  "az": "Box__O9ooK7",
  "wy": "Box_1__A-44zK",
  "pv": "Box_2__DUVf8X",
  "MJ": "FormControl__IX-4KF",
  "ks": "TextInput__if1FSZ",
};

module.exports = exports;
